import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

export default () => {
	const lightbox = new PhotoSwipeLightbox({
		gallery: ".media-library .block__items",
		children: ".item",
		showHideAnimationType: "zoom",
		secondaryZoomLevel: 2,
		maxZoomLevel: 2,
		pswpModule: () => import("photoswipe"),
	});

	lightbox.on("uiRegister", function () {
		//@ts-ignore
		lightbox.pswp.ui.registerElement({
			name: "download-button",
			order: 8,
			isButton: true,
			tagName: "a",

			// SVG with outline
			html: {
				isCustomSVG: true,
				inner: '<path d="M20.5 14.3 17.1 18V10h-2.2v7.9l-3.4-3.6L10 16l6 6.1 6-6.1ZM23 23H9v2h14Z" id="pswp__icn-download"/>',
				outlineID: "pswp__icn-download",
			},

			onInit: (el: any, pswp: any) => {
				el.setAttribute("download", "");
				el.setAttribute("target", "_blank");
				el.setAttribute("rel", "noopener");

				pswp.on("change", () => {
					el.href = pswp.currSlide.data.src;
				});
			},
		});

		//@ts-ignore
		lightbox.pswp.ui.registerElement({
			name: 'custom-caption',
			order: 9,
			isButton: false,
			appendTo: 'root',
			html: '',
			onInit: (el: any, pswp: any) => {
				//@ts-ignore
				lightbox.pswp.on('change', () => {
					const currSlideElement : HTMLElement = pswp.currSlide?.data?.element;
					const captionHTML: string = currSlideElement.querySelector('img')?.dataset?.caption as string;

					const node = document.createTextNode(captionHTML);
					el.appendChild(node);
				});
			}
		});
	});

	lightbox.init();
};
